/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     通道链接 + 联动 API
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'
const jsApiHost = process.env.VUE_APP_GENERAL_API_HOST

export function singleLinkApi(data) {
  return request({
    url: '?c=dev&a=link&do=single',
    method: 'post',
    data
  })
}

export function batchLinkApi(data) {
  return request({
    url: '?c=dev&a=link&do=batch',
    method: 'post',
    data
  })
}

export function aiLinkGetall(params) {
  return request({
    url: jsApiHost + '/dev/ailink/getall',
    method: 'get',
    params
  })
}

export function aiLinkAdd(data) {
  return request({
    url: jsApiHost + '/dev/ailink/post',
    method: 'post',
    data
  })
}

export function aiLinkDelete(data) {
  return request({
    url: jsApiHost + '/dev/ailink/delete',
    method: 'post',
    data
  })
}

export function aiLinkAuth(data) {
  return request({
    url: jsApiHost + '/dev/ailink/auth',
    method: 'post',
    data
  })
}